// extracted by mini-css-extract-plugin
module.exports = {"tagsInput":"_3CuDB6","form":"f2omcM"};